import React, { CSSProperties, useEffect } from 'react';
import { DailyReport } from 'components/features/new-report/daily-report/DailyReport';
import { WeeklyReport } from 'components/features/new-report/weekly-report/WeeklyReport';
import { MonthlyReport } from 'components/features/new-report/monthly-report/MonthlyReport';
// import { YearlyReport } from 'components/features/new-report/monthly-report/YearlyReport';
import { useRouting } from 'hooks/useRouting';
import { useLocation, Redirect } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useHeader as useHeader_ } from 'hooks/useHeader';
import Loading from 'components/commons/loading/Loading';
import { PremiumCheck as RawPremiumCheck } from 'components/commons/premium-check/PremiumCheck';
import { AboutExchangeRateModalProvider } from 'components/features/modal/AboutExchangeRateModal';
import { isIosAppNotPremium } from 'components/features/utils/userStatus';
import { useNotAggregatedPage } from 'hooks/useNotAggregatedPage';
import { GetUserResut, getUser } from 'config/api';

// 型 ============================================================================================

type NewReportProps = Record<string, unknown>;

type PagerProps = {
  frequency: Frequency;
  handleClickDailyButton: () => void;
  handleClickWeeklyButton: () => void;
  handleClickMonthlyButton: () => void;
  handleClickYearlyButton: () => void;
};

export const FREQUENCY = {
  DAILY: 'dailyreport',
  WEEKLY: 'weeklyreport',
  MONTHLY: 'monthlyreport',
  YEARLY: 'yearlyreport',
} as const;
export type Frequency = typeof FREQUENCY[keyof typeof FREQUENCY];
type Page = {
  frequency: Frequency;
  query: string | null;
};

// 実装 ============================================================================================

// TODO: 表示速度改善対応リリースのため一時的に年次レポートへの同線をコメントアウト
// const Pager: React.FC<PagerProps> = ({
//   frequency,
//   handleClickDailyButton,
//   handleClickMonthlyButton,
//   handleClickWeeklyButton,
//   handleClickYearlyButton,
// }) => {
//   const [scrollTarget, setScrollTarget] = useState(true);
//   const scroll = useCallback(() => {
//     if (frequency !== FREQUENCY.YEARLY || scrollTarget === false) return;
//     const element = document.getElementById('scroll');
//     if (element) {
//       element.scrollLeft = element.scrollWidth;
//     }
//     setScrollTarget(false);

//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [scrollTarget]);

//   return (
//     <>
//       {/* PC */}
//       <div className="hidden lg:flex w-full report-tab-block p-6 overflow-hidden">
//         <div className="whitespace-no-wrap tab-header-list w-full h-full text-center">
//           <div
//             className={
//               'inline-block whitespace-normal align-top tab-header-list-item cursor-pointer' +
//               (frequency === FREQUENCY.DAILY ? ' is-active' : '')
//             }
//             style={{ width: '23%' }}
//             onClick={handleClickDailyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/day.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 日次
//                 <br />
//                 日々の確認
//               </div>
//             </div>
//           </div>
//           <div
//             className={
//               'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
//               (frequency === FREQUENCY.WEEKLY ? ' is-active' : '')
//             }
//             style={{ width: '23%' }}
//             onClick={handleClickWeeklyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/week.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 週次
//                 <br />
//                 振り返り
//               </div>
//             </div>
//           </div>
//           <div
//             className={
//               'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
//               (frequency === FREQUENCY.MONTHLY ? ' is-active' : '')
//             }
//             style={{ width: '23%' }}
//             onClick={handleClickMonthlyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/month.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 月次
//                 <br />
//                 今後の展望
//               </div>
//             </div>
//           </div>
//           <div
//             className={
//               'inline-block whitespace-nowrap align-top tab-header-list-item ml-4 cursor-pointer' +
//               (frequency === FREQUENCY.YEARLY ? ' is-active' : '')
//             }
//             style={{ width: '23%' }}
//             onClick={handleClickYearlyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/month.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 年次
//                 <br />
//                 今後の展望
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       {/* SP */}
//       <div
//         className="flex lg:hidden w-full overflow-x-scroll overflow-y-hidden report-tab-block py-6 px-3"
//         ref={scroll}
//         id="scroll">
//         <div className="whitespace-no-wrap tab-header-list w-full h-full text-center">
//           <div
//             className={
//               'inline-block whitespace-normal align-top tab-header-list-item cursor-pointer' +
//               (frequency === FREQUENCY.DAILY ? ' is-active' : '')
//             }
//             style={{ width: '27%' }}
//             onClick={handleClickDailyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/day.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 日次
//                 <br />
//                 日々の確認
//               </div>
//             </div>
//           </div>
//           <div
//             className={
//               'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
//               (frequency === FREQUENCY.WEEKLY ? ' is-active' : '')
//             }
//             style={{ width: '27%' }}
//             onClick={handleClickWeeklyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/week.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 週次
//                 <br />
//                 振り返り
//               </div>
//             </div>
//           </div>
//           <div
//             className={
//               'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
//               (frequency === FREQUENCY.MONTHLY ? ' is-active' : '')
//             }
//             style={{ width: '27%' }}
//             onClick={handleClickMonthlyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/month.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 月次
//                 <br />
//                 今後の展望
//               </div>
//             </div>
//           </div>
//           <div
//             className={
//               'inline-block whitespace-nowrap align-top tab-header-list-item mx-4 cursor-pointer' +
//               (frequency === FREQUENCY.YEARLY ? ' is-active' : '')
//             }
//             style={{ width: '27%' }}
//             onClick={handleClickYearlyButton}>
//             <div className="flex flex-col items-center">
//               <div className="h-7.5 w-7.5 mt-auto mb-2">
//                 <img
//                   src="/static/images/report/month.svg"
//                   alt=""
//                   className="w-full"
//                 />
//               </div>
//               <div className="text-xs leading-4">
//                 年次
//                 <br />
//                 今後の展望
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

const Pager: React.FC<PagerProps> = ({
  frequency,
  handleClickDailyButton,
  handleClickMonthlyButton,
  handleClickWeeklyButton,
  handleClickYearlyButton,
}) => {
  // const [scrollTarget, setScrollTarget] = useState(true);
  // const scroll = useCallback(() => {
  //   if (frequency !== FREQUENCY.YEARLY || scrollTarget === false) return;
  //   const element = document.getElementById('scroll');
  //   if (element) {
  //     element.scrollLeft = element.scrollWidth;
  //   }
  //   setScrollTarget(false);

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [scrollTarget]);

  return (
    <>
      {/* PC */}
      <div className="hidden lg:flex w-full report-tab-block p-6 overflow-hidden">
        <div className="whitespace-no-wrap tab-header-list w-full h-full flex flex-row text-center">
          <div
            className={
              'inline-block whitespace-normal align-top tab-header-list-item cursor-pointer' +
              (frequency === FREQUENCY.DAILY ? ' is-active' : '')
            }
            onClick={handleClickDailyButton}>
            <div className="flex flex-col items-center">
              <div className="h-7.5 w-7.5 mt-auto mb-2">
                <img
                  src="/static/images/report/day.svg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div className="text-xs leading-4">
                日次
                <br />
                日々の確認
              </div>
            </div>
          </div>
          <div
            className={
              'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
              (frequency === FREQUENCY.WEEKLY ? ' is-active' : '')
            }
            onClick={handleClickWeeklyButton}>
            <div className="flex flex-col items-center">
              <div className="h-7.5 w-7.5 mt-auto mb-2">
                <img
                  src="/static/images/report/week.svg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div className="text-xs leading-4">
                週次
                <br />
                振り返り
              </div>
            </div>
          </div>
          <div
            className={
              'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
              (frequency === FREQUENCY.MONTHLY ? ' is-active' : '')
            }
            onClick={handleClickMonthlyButton}>
            <div className="flex flex-col items-center">
              <div className="h-7.5 w-7.5 mt-auto mb-2">
                <img
                  src="/static/images/report/month.svg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div className="text-xs leading-4">
                月次
                <br />
                今後の展望
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* SP */}
      <div
        className="flex lg:hidden w-full overflow-x-scroll overflow-y-hidden report-tab-block py-6 px-6"
        id="scroll">
        <div className="whitespace-no-wrap tab-header-list w-full h-full flex flex-row text-center">
          <div
            className={
              'inline-block whitespace-normal align-top tab-header-list-item cursor-pointer' +
              (frequency === FREQUENCY.DAILY ? ' is-active' : '')
            }
            onClick={handleClickDailyButton}>
            <div className="flex flex-col items-center">
              <div className="h-7.5 w-7.5 mt-auto mb-2">
                <img
                  src="/static/images/report/day.svg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div className="text-xs leading-4">
                日次
                <br />
                日々の確認
              </div>
            </div>
          </div>
          <div
            className={
              'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
              (frequency === FREQUENCY.WEEKLY ? ' is-active' : '')
            }
            onClick={handleClickWeeklyButton}>
            <div className="flex flex-col items-center">
              <div className="h-7.5 w-7.5 mt-auto mb-2">
                <img
                  src="/static/images/report/week.svg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div className="text-xs leading-4">
                週次
                <br />
                振り返り
              </div>
            </div>
          </div>
          <div
            className={
              'inline-block whitespace-normal align-top tab-header-list-item ml-4 cursor-pointer' +
              (frequency === FREQUENCY.MONTHLY ? ' is-active' : '')
            }
            onClick={handleClickMonthlyButton}>
            <div className="flex flex-col items-center">
              <div className="h-7.5 w-7.5 mt-auto mb-2">
                <img
                  src="/static/images/report/month.svg"
                  alt=""
                  className="w-full"
                />
              </div>
              <div className="text-xs leading-4">
                月次
                <br />
                今後の展望
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const newReportPathRegex = /^\/(?<path>dailyreport|weeklyreport|monthlyreport|yearlyreport)(?:\?period=(?<query>\d.*))?.*$/;

const parsePage = (pathname: string): Page | null => {
  const regex = newReportPathRegex;
  const result = regex.exec(pathname);
  if (!result || result.groups === undefined) return null;
  if (!Object.values(FREQUENCY).find(v => v === result.groups?.path))
    return null;
  const query =
    typeof Number(result.groups?.query) === 'number'
      ? result.groups?.query
      : null;
  const path = result.groups?.path as Frequency;
  return { frequency: path, query };
};

const useHeader = (): void => {
  const [, { setDefaultHeader }] = useHeader_();
  useEffect(() => {
    setDefaultHeader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

const useIosCheck = (
  frequency: string
): React.FC<{
  children: React.ReactElement;
}> => {
  const IosCheck: React.FC<{ children: React.ReactElement }> = ({
    children,
  }) => {
    if (isIosAppNotPremium() && frequency !== FREQUENCY.DAILY) {
      return <Redirect to="/dailyreport" />;
    } else {
      return children;
    }
  };

  return IosCheck;
};

const usePremiumCheck = (
  frequency: string
): React.FC<{
  children: React.ReactElement;
}> => {
  const isForPremium =
    frequency === FREQUENCY.WEEKLY || frequency === FREQUENCY.MONTHLY;

  const PremiumCheck: React.FC<{ children: React.ReactElement }> = ({
    children,
  }) => {
    const pattern = frequency === FREQUENCY.WEEKLY ? 4 : 7;

    if (isForPremium)
      return (
        <>
          <RawPremiumCheck layoutPattern={pattern}>{children}</RawPremiumCheck>
        </>
      );
    return children;
  };
  return PremiumCheck;
};

export const reportLoadingStyle: CSSProperties = { marginTop: '2.5rem' };

const NewReport: React.FC<NewReportProps> = props => {
  const { NotAggregatedPageSwitcher } = useNotAggregatedPage({
    title: 'レポート',
    alreadyHitBrokers: 'notHit',
  });
  useHeader();
  const { replaceRouting } = useRouting();
  const { pathname, search } = useLocation();
  const setQuery = (q: string, frequency: Frequency): void => {
    replaceRouting({ path: `/${frequency}?period=${q}` }, true);
  };

  const page = parsePage(pathname + search) ?? {
    frequency: FREQUENCY.DAILY,
    query: null,
  };

  const IosCheck = useIosCheck(page.frequency);
  // なるべく premium check等パスを制御するものははJSX外にまとめたい
  const NewReportPremiumCheck = usePremiumCheck(page.frequency);

  const { data: userInfoData } = useQuery('reportUserInfo', fetchUserInfo, {
    refetchOnWindowFocus: false,
  });

  if (userInfoData === null || userInfoData === undefined)
    return <Loading style={reportLoadingStyle} loading={true} />;
  const userInfo = userInfoData as GetUserResut;

  const setPathTo = (wholePath: string): void => {
    replaceRouting({ path: wholePath }, true);
  };

  const handleClickDailyButton = (): void => {
    setPathTo(`/${FREQUENCY.DAILY}`);
  };
  const handleClickWeeklyButton = (): void => {
    setPathTo(`/${FREQUENCY.WEEKLY}`);
  };
  const handleClickMonthlyButton = (): void => {
    setPathTo(`/${FREQUENCY.MONTHLY}`);
  };
  const handleClickYearlyButton = (): void => {
    setPathTo(`/${FREQUENCY.YEARLY}`);
  };

  return (
    <>
      <AboutExchangeRateModalProvider>
        <IosCheck>
          <NewReportPremiumCheck>
            <NotAggregatedPageSwitcher loadingStyle={reportLoadingStyle}>
              {!isIosAppNotPremium() && (
                <Pager
                  {...{
                    frequency: page.frequency,
                    handleClickDailyButton,
                    handleClickWeeklyButton,
                    handleClickMonthlyButton,
                    handleClickYearlyButton,
                  }}
                />
              )}
              {page.frequency === FREQUENCY.DAILY && userInfo !== null && (
                <DailyReport
                  {...{
                    isLinkedLine: userInfo.LinkedLine,
                  }}
                />
              )}
              {page.frequency === FREQUENCY.WEEKLY && userInfo !== null && (
                <WeeklyReport
                  {...{
                    userName: userInfo.Name,
                    isLinkedLine: userInfo?.LinkedLine,
                    query: page.query,
                    setQuery,
                  }}
                />
              )}
              {page.frequency === FREQUENCY.MONTHLY && userInfo !== null && (
                <MonthlyReport
                  {...{
                    userName: userInfo.Name,
                    isLinkedLine: userInfo.LinkedLine,
                    query: page.query,
                    setQuery,
                  }}
                />
              )}
              {/* TODO: 表示速度改善対応リリースのため一時的に年次レポートへの同線をコメントアウト */}
              {/* {page.frequency === FREQUENCY.YEARLY && userInfo !== null && (
              <YearlyReport
                {...{
                  userName: userInfo.Name,
                  isLinkedLine: userInfo.LinkedLine,
                  query: page.query,
                  setQuery,
                }}
              />
            )} */}
            </NotAggregatedPageSwitcher>
          </NewReportPremiumCheck>
        </IosCheck>
      </AboutExchangeRateModalProvider>
    </>
  );
};

const fetchUserInfo = async () => {
  return await getUser();
};

export default NewReport;
